<template>
  <div class="qrcode-management">
    <div class="header">
      <div style="display:flex;align-items:center;justify-content:center">
        <h2>二维码管理</h2>
        <el-button :disabled="selectIds.length == 0" style="margin-left:20px;" type="primary" size="mini" icon="el-icon-download" @click="batchDownloads">批量下载</el-button>
      </div>
      <el-dropdown split-button type="primary" :disabled="loading" @click="handleCreate" @command="generateQuantity">
        生成新二维码
        <el-dropdown-menu slot="dropdown" >
          <el-dropdown-item v-for="(item,index) in 3" :key="index" :command="item*10">{{item*10}}个</el-dropdown-item>
          
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-button type="primary" split-button @click="handleCreate">
        
      </el-button> -->
    </div>
    <!-- <el-row :gutter="20">
      <el-col :offset="1" :span="2">
        <el-button  type="primary" size="mini" icon="el-icon-download">批量下载</el-button>
      </el-col>
    </el-row> -->
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      v-loading="loading"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <!-- <el-table-column label="二维码" width="120">
        <template slot-scope="scope">
          <img :src="scope.row.qrCode" class="qrcode-image" alt="二维码">
        </template>
      </el-table-column> -->
      <el-table-column prop="qrCodeNo" label="编号"></el-table-column>
      <el-table-column prop="userId" label="绑定用户ID">
        <template slot-scope="scope">
          <span v-if="scope.row.userId">{{ scope.row.userName|| scope.row.userId}}</span>
          <el-button v-else size="mini" @click="bindUser(scope.row)">绑定用户</el-button>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="250">
        <template slot-scope="scope">
          <el-input v-model="scope.row.remarks" placeholder="请输入用户备注" @blur="bindUserRemark(scope.row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="creatTime" label="创建时间" width="160"></el-table-column>
      <el-table-column label="状态" width="180">
        <template slot-scope="scope">
          <el-switch
          v-model="scope.row.status"
          :active-value="0"
          :inactive-value="1"
          active-color="#13ce66"
          inactive-color="#5f6368"
          @change="changeStatus($event,scope.row.id)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="mini" :disabled="scope.row.status == 1" type="primary" icon="el-icon-download" @click="processImage(scope.row)">下载</el-button>
          <el-button size="mini" v-if="scope.row.userId" type="warning" icon="el-icon-s-order" @click="getpromoteUsers(scope.row)">推广用户</el-button>
          <!-- <el-button size="mini" :disabled="scope.row.status == 1" type="primary" icon="el-icon-view" @click="priviewImg(scope.row)">预览</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 绑定用户对话框 -->
    <el-dialog title="绑定用户" :visible.sync="bindDialogVisible" width="30%">
      <el-form :model="bindForm" label-width="80px">
        <el-form-item label="用户ID">
          <el-select v-model="bindForm.userId" filterable :filter-method="filterCustomer">
            <el-option 
              v-for="item in customerList" 
              :key="item.id" 
              :label="item.nickName"
              :value="item.id"
            ></el-option>
            <template>
            <div>
                <el-button @click="loadMore" style="margin:0 auto">加载更多</el-button>
            </div>
            </template>
                </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bindDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmBind">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog width="500" :visible="priviewImgShow" :before-close="(done)=>{this.priviewImgShow = false;done()}">
      <div id="print-me" style="width:100%;height:100%;display: flex; align-items: center; justify-content: center;">
        <img  :src="processedImageUrl" alt="">
      </div>
      <el-button style="margin-top:20px" type="primary" size="mini" icon="el-icon-printer" v-print="'#print-me'">打印</el-button>
    </el-dialog>
    <el-dialog width="900" :visible.sync="promoteUsersShow" :title="protoTitle">
      <el-table :data="promoteUsers">
        <el-table-column label="序号" prop="id" align="center"></el-table-column>
        <el-table-column label="用户id" prop="userId" align="center"></el-table-column>
        <el-table-column label="用户姓名" prop="userName" align="center" width="200"></el-table-column>
        <el-table-column label="奖金" prop="price" align="center"></el-table-column>
        <el-table-column label="注册时间" prop="creatTime" align="center" width="200"></el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleProCurrentChange"
        :current-page="promoteParams.current"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="promoteUsersTotal">
      </el-pagination>
    </el-dialog>

    <canvas ref="canvas" style="display: none;"></canvas>
  </div>
</template>

<script>
import {
  getList,
  creatBatchList,
  bindUsers,
  userList,
  getLowerUserList
} from '@/api/index'
import print from 'vue-print-nb';
import JSZip from 'jszip';
import FileSaver from 'file-saver';

export default {
  name: 'HomeView',
  directives: { print },
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      bindDialogVisible: false,
      bindForm: {
        id: null,
        userId: ''
      },
      localImageUrl:'',
      processedImageUrl: null,
      customerList:[],
      userParams:{
        current:1,
        size:20,
        phone:''
      },
      priviewImgShow:false,
      selectIds:[],
      createNum:10,
      promoteUsersShow:false,
      promoteUsers:[],
      promoteUsersTotal:0,
      promoteParams:{
        code:'',
        current:1,
        size:10
      },
      protoTitle:''
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    bindUserRemark(value){
      bindUsers({
        id:value.id,
        remarks:value.remarks
      }).then(()=>{
        this.$message.success(`操作成功！`)
        this.fetchData()
      })
    },
    handleProCurrentChange(e){
      this.promoteParams.current = e
      this.getpromoteUsers()
    },
    getpromoteUsers(value){
      console.log(`output->value`,value)
      if(value){
        this.protoTitle = value.userName + '推广人员列表'
        this.promoteParams.current = 1
        this.promoteParams.code = value.qrCodeNo
      }
      getLowerUserList(value?.qrCodeNo||this.promoteParams.code,this.promoteParams).then(res=>{
        this.promoteUsersShow = true
        this.promoteUsers = res.data
        this.promoteUsersTotal = res.total
      })
    },
    // 批量打印
    batchDownloads(){
      if(this.selectIds.length == 0) return this.$message.error('无有效二维码！');
      // this.selectIds.forEach(item=>{
      //   this.processImage(item,true)
      // })


      // 以下是写的要批量下载的方法
      const zip = new JSZip();
      const promises = this.selectIds.map(item => this.processImage(item, false));
      Promise.all(promises).then(results => {
        results.forEach(result => {
          zip.file(
            `智行临沂_${result.item.remarks}_${result.item.qrCodeNo}.png`,
            result.data.split(',')[1],
            { base64: true }
          );
        });
  
        zip.generateAsync({ type: 'blob', compression: 'DEFLATE' })
          .then(content => {
            FileSaver.saveAs(content, '二维码批量下载.zip');
          })
          .catch(error => {
            console.error('生成ZIP失败:', error);
            this.$message.error('下载失败，请重试');
          });
      })
      .catch(error => {
        console.error('处理二维码失败:', error);
        this.$message.error('处理二维码失败');
      });
    },

    // 获取数据
    fetchData() {
      this.loading = true
      let data = {
        current:this.currentPage,
        size:this.pageSize
      }
      getList(data).then(res=>{
        this.tableData = res.data
        this.total = res.total
        this.loading = false
      })
    },
    handleSelectionChange(e){
      if(e.some(i=>i.status == 1)){
        this.$message.info('已过滤掉禁用的二维码！')
        this.selectIds = e.filter(item=>item.status === 0)
      }else{
        this.selectIds = e
      }
    },

    filterCustomer(e){
      this.userParams={
        current:1,
        size:20,
        phone:e
      }
      this.customerList = []
      this.getUserList()
    },
    async priviewImg(options){
      this.processedImageUrl = ''
      await this.processImage(options,false)
      if(this.processedImageUrl){
        this.priviewImgShow = true
      }
    },
    async processImage(options,isDownload = true) {
      if (!options.qrCode) {
        alert('请输入二维码图片URL');
        return;
      }
      
      this.loading = true;
      
      try {
        // 创建图片对象
        const img = new Image();
        img.crossOrigin = 'anonymous'; // 处理跨域问题
        
        // 等待图片加载完成
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
          img.src = options.qrCode;
        });
        
    
        const canvas = this.$refs.canvas;
        const ctx = canvas.getContext('2d');
        
        canvas.width = img.width + 20;
        canvas.height = img.height + 100; 
        
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        // 绘制二维码图片
        ctx.drawImage(img, 10, 40, img.width, img.height);
        
        // 设置文字样式
        ctx.fillStyle = '#333';
        ctx.textAlign = 'center';
        
        ctx.font = 'bold 24px Microsoft YaHei';
        ctx.fillText('————智行临沂————', canvas.width / 2, 25);
        
        ctx.font = '18px Microsoft YaHei';
        ctx.fillText(options.remarks || '', canvas.width / 2, img.height + 60);
        ctx.fillText(`编号：${options.qrCodeNo}`, canvas.width / 2, img.height + 90);
        
        // 转换为DataURL
        this.processedImageUrl = canvas.toDataURL('image/png');
        if(isDownload){
          this.downLoad(options)
        }else{
          // 批量下载添加功能
          return {
            data:canvas.toDataURL('image/png'),
            item:options
          }
            
        }
      } catch (error) {
        this.$message.error('图片处理失败，请检查图片URL是否正确或尝试其他图片');
        // this.processImage(options)
      } finally {
        this.loading = false;
      }
    },
    downLoad(options){
      if (!this.processedImageUrl) return;
      
      // 创建下载链接
      const link = document.createElement('a');
      link.href = this.processedImageUrl;
      link.download = `智行临沂_${options.remarks}_${options.qrCodeNo}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    downloadImageFromUrl(imageUrl, filename = 'image') {
      // 创建一个新的a标签
      const link = document.createElement('a');
      link.href = imageUrl.qrCode;
      
      // 设置下载属性
      link.download = `${filename}.${imageUrl.qrCode.split('.').pop() || 'png'}`;
      
      // 触发点击事件
      document.body.appendChild(link);
      link.click();
      
      // 清理DOM
      document.body.removeChild(link);
    },



    // 每页条数改变
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    
    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchData()
    },
    
    generateQuantity(e){
      this.createNum = e
      this.handleCreate()
    },
    // 生成新二维码
    handleCreate() {
      this.loading = true
      creatBatchList({num:this.createNum}).then(()=>{
        this.loading = false
        this.$message.success('操作成功！')
        this.currentPage = 1
        this.fetchData()
      })
     
    },
    
    
    changeStatus(e,id) {
      bindUsers({
        id,
        status:e
      }).then(()=>{
        this.$message.success(`操作成功！`)
        this.fetchData()
      })
      
    },
    
    // 绑定用户
    bindUser(row) {
      this.userParams={
        current:1,
        size:20,
        phone:''
      }
      this.customerList = []
      this.getUserList()
      this.bindForm.id = row.id
      this.bindForm.userId = ''
      this.bindDialogVisible = true
    },
    getUserList(){
      userList(this.userParams).then(res=>{
        this.customerList = [...this.customerList,...res.data]
      })
    },
    loadMore(){
      this.userParams.current++
      this.getUserList()
    },
    
    // 确认绑定
    confirmBind() {
      if (!this.bindForm.userId) {
        this.$message.warning('请选择用户ID')
        return
      }
      
       bindUsers(this.bindForm).then(()=>{
        this.$message.success(`已成功将二维码 ${this.bindForm.id} 绑定到用户 ${this.bindForm.userId}`)
        this.bindDialogVisible = false
        this.tableData = []
        this.fetchData()
       })
      
    }
  }
}
</script>

<style scoped>
@media print {
  @page {
    size: A4;
    margin: 2cm; /* 或者根据你的需要调整边距 */
  }
 
  body {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}
.qrcode-management {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.qrcode-image {
  width: 80px;
  height: 80px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>